import React from 'react';

import styles from '../../components/Divider/Divider.module.scss';

const Divider: React.FC = () => <hr className={styles.divider} />;

export { Divider };
